import { takeLatest } from 'redux-saga/effects'
import { requestRevPennyDrop, getRevPennyDropStatus } from './bankDetailsSlice'
import { handleGetRevPennyDropStatus, handleRequestRevPennyDrop } from './bankDetailsHandler'

export function* requestRevPennyDropSaga() {
  yield takeLatest(requestRevPennyDrop.type, handleRequestRevPennyDrop)
}

export function* getRevPennyDropStatusSaga() {
  yield takeLatest(getRevPennyDropStatus.type, handleGetRevPennyDropStatus)
}
